import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import {
  CropVarietySpecificNorm,
  GetCropVarietySpecificNormsResponse,
  UpsertCropVarietySpecificNormResponse,
  CropVarietySpecificNormFilter,
  DeleteCropVarietySpecificNormResponse,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class CropVarietySpecificNormApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/field-report/secure/cropvarietyspecificnorm';

  getCropVarietySpecificNorms(pageNumber: number, pageSize: number, filter: CropVarietySpecificNormFilter): Observable<GetCropVarietySpecificNormsResponse> {
    let url = `${this.baseUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (filter.year) {
      url += `&calendarYear=${filter.year}`;
    }
    return this.http.get<GetCropVarietySpecificNormsResponse>(url);
  }

  upsertCropVarietySpecificNorm(cropVarietySpecificNorm: CropVarietySpecificNorm) {
    return this.http.post<UpsertCropVarietySpecificNormResponse>(this.baseUrl, cropVarietySpecificNorm, {});
  }

  deleteCropVarietySpecificNorm(cropVarietySpecificNormId: number) {
    return this.http.delete<DeleteCropVarietySpecificNormResponse>(this.baseUrl + '/' + cropVarietySpecificNormId);
  }
}
